<template>
  <div>
      <SaleDetail title="Sales Order" type="SO"></SaleDetail>
  </div>
</template>

// <script>
import SaleDetail from './details.vue'
export default {
   components: { SaleDetail },


}
</script>

<style>

</style>